import {
    createRouter,
    createWebHistory
} from 'vue-router';

import {
    useAuthStore
} from '@/stores/auth'
import AppLayout from '@/layout/AppLayout.vue';

const routes = [{
        path: '/',
        component: AppLayout,
        children: [{
                path: '/',
                name: 'dashboard',
                exact: true,
                component: () => {
                    const authStore = useAuthStore();
                    // Kullanıcı rolüne göre farklı bileşenleri dinamik olarak yükle
                    if (authStore.allowedLinks.includes('is_musteri') || authStore.allowedLinks.includes('is_bayi')) {
                        return import('@/views/dashboards/DashboardMusteri.vue');
                    } else {
                        return import('@/views/dashboards/Dashboard.vue');
                    }
                },
                meta: {
                    breadcrumb: [{
                        label: 'Ürünler ve Stoklar'
                    }],
                    requiresAuth: true
                }
            },
            {
                path: '/dashboard/active-users',
                name: 'dashboardactiveusers',
                exact: true,
                component: () =>
                    import('@/views/dashboards/DashboardUser.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Kullanıcı Aktiviteleri'
                    }],
                    requiresAuth: true,
                }
            },
            {
                path: '/dashboard/orders',
                name: 'dashboardorders',
                exact: true,
                component: () =>
                    import('@/views/dashboards/DashboardOrder.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Siparişler'
                    }],
                    requiresAuth: true,
                }
            },

        ]
    },
    {
        path: '/',
        component: AppLayout, // AppLayoutCompany,
        //beforeEnter: Tr.routeMiddleware,
        children: [{
                path: '/user-management',
                name: 'usermanagement',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/user-management/UserList.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Kullanıcı Yönetimi'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser']
                }
            }

        ]
    },
    {
        path: '/',
        component: AppLayout, // AppLayoutCompany,
        //beforeEnter: Tr.routeMiddleware,
        children: [{
                path: '/orders',
                name: 'orders',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/orders/List.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Satışlar'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser']
                }
            },
            {
                path: '/orders/customers',
                name: 'orderscustomers',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/orders/CustomerList.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Satışlar'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser']
                }
            }

        ]
    },
    {
        path: '/',
        component: AppLayout,
        children: [{
                path: '/apply',
                name: 'apply',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/apply/List.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Başvuru Listesi'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser']
                }
            },
            {
                path: '/apply/register',
                name: 'applyregister',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/apply/Register.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'İşletme Hesabı Başvuru Formu'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser', 'is_musteri', 'is_bayi', 'is_personel']
                }
            }
        ]
    },
    {
        path: '/',
        component: AppLayout, // AppLayoutCompany,
        //beforeEnter: Tr.routeMiddleware,
        children: [{
                path: '/category',
                name: 'category',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/category/Category.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Kategoriler'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser']
                }
            }

        ]
    },
    {
        path: '/',
        component: AppLayout, // AppLayoutCompany,
        //beforeEnter: Tr.routeMiddleware,
        children: [{
                path: '/brand',
                name: 'brand',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/brand/List.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Markalar'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser']
                }
            }

        ]
    },
    {
        path: '/',
        component: AppLayout, // AppLayoutCompany,
        //beforeEnter: Tr.routeMiddleware,
        children: [{
                path: '/product',
                name: 'product',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/product/List.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Ürünler'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser', 'is_musteri', 'is_bayi']
                }
            },
            {
                path: '/product/price-entry',
                name: 'productpriceentry',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/product/PriceEntry.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Fiyat Girilecek'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser']
                }
            },
            {
                path: '/product/detail/:id',
                name: 'productdetail',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/product/Detail.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Ürün Detay'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser', 'is_musteri', 'is_bayi']
                }
            },
            {
                path: '/product/sell/:id',
                name: 'productsell',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/product/ProductSell.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Ürün Satışı'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser']
                }
            },
            // {
            //     path: '/product/test',
            //     name: 'producttest',
            //     exact: true,
            //     beforeEnter: (to, from, next) => {
            //         const authStore = useAuthStore();
            //         if (authStore.isAuth) {
            //             next();
            //         } else {
            //             next('/auth/login');
            //         }
            //     },
            //     component: () =>
            //         import('@/views/product/Test.vue'),
            //     meta: {
            //         breadcrumb: [{
            //             label: 'Ürünler'
            //         }],
            //         requiresAuth: true,
            //         allowedLinks: ['is_yonetici', 'is_superuser']
            //     }
            // }

        ]
    },
    {
        path: '/',
        component: AppLayout, // AppLayoutCompany,
        //beforeEnter: Tr.routeMiddleware,
        children: [{
                path: '/market-place',
                name: 'marketplace',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/market-place/List.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Markalar'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser']
                }
            }

        ]
    },
    {
        path: '/',
        component: AppLayout, // AppLayoutCompany,
        //beforeEnter: Tr.routeMiddleware,
        children: [{
                path: '/features',
                name: 'features',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/features/List.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Ürün Özellikleri'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser']
                }
            }

        ]
    },

    {
        path: '/',
        component: AppLayout, // AppLayoutCompany,
        //beforeEnter: Tr.routeMiddleware,
        children: [{
            path: '/user/profile',
            name: 'userprofile',
            exact: true,
            beforeEnter: (to, from, next) => {
                const authStore = useAuthStore();
                if (authStore.isAuth) {
                    next();
                } else {
                    next('/auth/login');
                }
            },
            component: () =>
                //import ('@/views/dashboards/Dashboard.vue'),
                import('@/views/user/Profile.vue'),
            meta: {
                breadcrumb: [{
                    label: 'Profil'
                }],
                requiresAuth: true,
            }
        }]
    },
    {
        path: '/',
        component: AppLayout, // AppLayoutCompany,
        //beforeEnter: Tr.routeMiddleware,
        children: [{
                path: '/satinalma',
                name: 'satinalma',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/satinalma/List.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Satınalma'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser']
                }
            }

        ]
    },
    {
        path: '/',
        component: AppLayout, // AppLayoutCompany,
        //beforeEnter: Tr.routeMiddleware,
        children: [{
                path: '/notification',
                name: 'notification',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/notification/NotificationSms.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Bildirimler'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser']
                }
            }

        ]
    },
    {
        path: '/',
        component: AppLayout, // AppLayoutCompany,
        //beforeEnter: Tr.routeMiddleware,
        children: [{
                path: '/notification/email',
                name: 'notificationemail',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/notification/NotificationEmail.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Bildirimler'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_yonetici', 'is_superuser']
                }
            }

        ]
    },
    {
        path: '/',
        component: AppLayout, // AppLayoutCompany,
        //beforeEnter: Tr.routeMiddleware,
        children: [{
                path: '/pages/version',
                name: 'version',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/pages/Version.vue'),

                meta: {
                    breadcrumb: [{
                        label: 'Version'
                    }],
                    requiresAuth: true,
                    //allowedLinks: ['is_yonetici', 'is_superuser', "is_kullanici", "is_temsilci"]
                }
            },
            {
                path: '/pages/test',
                name: 'test',
                exact: true,
                beforeEnter: (to, from, next) => {
                    const authStore = useAuthStore();
                    if (authStore.isAuth) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/pages/Test.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Test Page'
                    }],
                    requiresAuth: true,
                    //allowedLinks: ['is_superuser']
                }
            },
            {
                path: '/pages/test-muhasebe',
                name: 'testmuhasebe',
                exact: true,
                beforeEnter: (to, from, next) => {
                    if (store.getters.isAuth === true) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/pages/TestMuhasebe.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Test Page'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_superuser']
                }
            },
            {
                path: '/pages/form',
                name: 'form',
                exact: true,
                beforeEnter: (to, from, next) => {
                    if (store.getters.isAuth === true) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },
                component: () =>
                    import('@/views/pages/Form.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Form'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_superuser']
                }
            },
            {
                path: '/pages/formprime',
                name: 'formprime',
                exact: true,
                beforeEnter: (to, from, next) => {
                    if (store.getters.isAuth === true) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },

                component: () =>
                    import('@/views/pages/TestFormPrime.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Form'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_superuser']
                }
            },
            {
                path: '/pages/formvee',
                name: 'formvee',
                exact: true,
                beforeEnter: (to, from, next) => {
                    if (store.getters.isAuth === true) {
                        next();
                    } else {
                        next('/auth/login');
                    }
                },

                component: () =>
                    import('@/views/pages/TestFormVee.vue'),
                meta: {
                    breadcrumb: [{
                        label: 'Form'
                    }],
                    requiresAuth: true,
                    allowedLinks: ['is_superuser']
                }
            }
        ]
    },
    {
        path: '/auth/login',

        name: 'login',
        component: () =>
            import('@/views/pages/auth/Login.vue')
    },
    {
        path: '/auth/verify-account',
        name: 'verifyaccount',
        component: () => import('@/views/pages/auth/VerifyAccount.vue')
    },
    {
        path: '/auth/confirm-email/:key',
        name: 'confirmemail',
        component: () => import('@/views/pages/auth/ConfirmEmail.vue')
    },
    {
        path: '/auth/access',
        name: 'accessDenied',
        component: () =>
            import('@/views/pages/auth/AccessDenied.vue')
    },

    {
        path: '/auth/error',
        name: 'error',
        component: () =>
            import('@/views/pages/auth/Error.vue')
    },
    {
        path: '/auth/error2',
        name: 'error2',
        component: () =>
            import('@/views/pages/auth/Error2.vue')
    },
    {
        path: '/auth/register',
        name: 'register',
        component: () =>
            import('@/views/pages/auth/Register.vue')
    },
    {
        path: '/auth/forgotpassword',
        name: 'forgotpassword',
        component: () =>
            import('@/views/pages/auth/ForgotPassword.vue')
    },
    {
        path: '/auth/password/reset/confirm/:uid/:token',
        name: 'passwordresetconfirm',
        component: () =>
            import('@/views/pages/auth/NewPassword.vue')
    },

    {
        path: '/auth/verification',
        name: 'verification',
        component: () =>
            import('@/views/pages/auth/Verification.vue')
    },
    {
        path: '/auth/lockscreen',
        name: 'lockscreen',
        component: () =>
            import('@/views/pages/auth/LockScreen.vue')
    },
    {
        path: '/pages/notfound',
        name: 'notfound',
        component: () =>
            import('@/views/pages/NotFound.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'notfound',
        component: () =>
            import('@/views/pages/NotFound.vue')
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return {
            left: 0,
            top: 0
        };
    }
});






router.beforeEach((to, from, next) => {
    const authStore = useAuthStore()

    if (to.meta.requiresAuth) {
        if (!authStore.isAuth) {
            next('/auth/login')
        } else {
            if (to.meta.allowedLinks && to.meta.allowedLinks.length > 0) {
                const intersection = authStore.allowedLinks.filter((link) =>
                    to.meta.allowedLinks.includes(link)
                )

                if (intersection.length === 0) {
                    next('/auth/access')
                } else {
                    next()
                }
            } else {
                next()
            }
        }
    } else {
        next()
    }
})


export default router;